import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import React, { createContext, useEffect, useState, useContext } from "react";
import { Box, Button, Container } from "@mui/material";
import QMentisBreadCrumb from '../../custom-components/QMentisBreadCrumb';
import DownloadIcon from '@mui/icons-material/Download';
import { Typography } from '@mui/material'
import { ReactComponent as AutomateIcon } from "../../../images/automateIcon.svg";
import FullscreenToggle from "../../custom-components/FullScreenToggle";
import TestCaseUI from '../../output-components/test-automation/TestCaseImported';
import Feature from '../../output-components/test-automation/FeatureFilesCreated';
import InputForm from '../../output-components/test-automation/PageSource';
import PageClass from '../../output-components/test-automation/PageClass';
import Locators from '../../output-components/test-automation/Locators';
import StepDefinition from '../../output-components/test-automation/StepDefinition';
import SaveAltRoundedIcon from '@mui/icons-material/SaveAltRounded';
import { ReactComponent as GenerateButton } from "../../../images/generateButton.svg";
import { featureFiles, featureFilesWithToolCalling, pageClassAPI, pageClassAPIWithToolCalling, stepDefinitionAPI, stepDefinitionWithToolCallingAPI, SeleniumCucumberProjectWithToolCalling } from '../../../services/webServices';
import { LoadingModalContext } from "../../main-pages/ServicePage";
import UploadBox from '../input-pages/UploadBox';
import { flattenArray, flattenObject } from "../../../utils/dataFlatteners";
import CommonDownload from "../../custom-components/CommonDownload";
import TestEnvironmentForm from '../../output-components/test-automation/TestEnvironment';
import MessagePopup from '../../popup-components/MessagePopup';
import JSZip from "jszip";
import { saveAs } from "file-saver";


export const TestCaseFlowDataContext = createContext(null);


const JavaSeleniumNewProjectOutputPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  // const [testCaseDetails, setTestCaseDetails] = useState([]);
  // const [featureFiles, setFeatureFiles] = useState("");
  // const [pageSources, setPageSources] = useState("");
  // const [locators, setLocators] = useState({});
  // const [pageClasses, setPageClasses] = useState("");
  // const [stepDefinitions, setstepDefinitions] = useState("");
  // const [downloadDialogOpen, setDownloadDialogOpen] = useState(false);

  const [testEnvironment, setTestEnviorment] = useState({});
  const [testCase, setTestCase] = useState({});
  const [featureFile, setFeatureFile] = useState('');
  const [pageSource, setPageSource] = useState('');
  const [locator, setLocator] = useState('');
  const [pageClass, setPageClass] = useState('');
  const [stepDefinition, setstepDefinition] = useState('');
  const { setLoadingState } = useContext(LoadingModalContext);
  const [downloadOpen, setDownloadOpen] = useState(false);
  const [confirmed, setConfirmed] = useState(false);
  const [popupOpen, setPopupOpen] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [sessionExpiredValue, setSessionExpiredValue] = useState(false);
  const [framework, setFramework] = useState('');
  const [projectType, setProjectType] = useState('');
  const [zipBlob, setZipBlob] = useState(null);

  useEffect(() => {
    console.log(location.state, "javaselenium");
    setProjectType(location.state?.projectType || "");
    setTestEnviorment(location.state?.testenvironmentdata || {});
    setTestCase(location.state?.testCaseData || {});
    setFeatureFile(location.state?.featureFileData || "");
    setPageSource(location.state?.pageSource || "");
    setLocator(location.state?.generatedLocators || {});
    setPageClass(location.state?.generatedPageclassData || "");
    setstepDefinition(location.state?.generatedStepDefinitionData || "");
    setFramework(location.state?.framework || "")
  }, [location.state?.testCaseData, location.state?.testenvironmentdata, location.state?.featureFileData, location.state?.pageSource, location.state?.generatedLocators, location.state?.generatedPageclassData, location.state?.generatedStepDefinitionData, location.state?.framework,
  location.state?.projectType
  ]);


  const breadCrumbs = [
    {
      title: "Set Test Environment",
      status: Object.entries(testEnvironment).length !== 0 || confirmed ? "Completed" : "In Progress",
    },

    {
      title: "Test Case Details",
      status: Object.entries(testCase).length > 0
        ? "Completed"
        : Object.entries(testEnvironment).length !== 0 && Object.entries(testCase).length === 0
          ? "In Progress"
          : "Not Started",
    },
    {
      title: "Feature Files",
      status:
        !!featureFile && featureFile !== ""
          ? "Completed"
          : Object.entries(testCase).length > 0
            ? "In Progress"
            : "Not Started",
    },
    {
      title: "Introduce SUT",
      status:
        !!pageSource && pageSource !== ""
          ? "Completed"
          : (!!featureFile && featureFile !== "")
            ? "In Progress"
            : "Not Started",
    },
    {
      title: "Generate Locators",
      status:
        Object.keys(locator).length > 0
          ? "Completed"
          : !!pageSource && pageSource !== ""
            ? "In Progress"
            : "Not Started",
    },
    {
      title: "Page Class",
      status:
        !!pageClass && pageClass !== ""
          ? "Completed"
          : Object.keys(locator).length > 0
            ? "In Progress"
            : "Not Started",
    },

    {
      title: "Step Definition",
      status:
        (!!stepDefinition && stepDefinition !== "")
          ? "Completed"
          : !!pageClass && pageClass !== ""
            ? "In Progress"
            : "Not Started",
    },
  ];

  const handleGenerateTestCases = async () => {
    // setLoading(true)
    let fake;

    const startProgress = (setProgress) => {
      let progress = 0;
      let stop = false;
      let finalMessageShown = false;

      const interval = setInterval(() => {
        if (stop) return;

        progress += 1.8;
        if (progress >= 97 && !finalMessageShown) {
          finalMessageShown = true;
          setLoadingState((prev) => ({
            ...prev,
            message: "Almost done! Fetching your output",
          }));
        }

        if (progress >= 97) progress = 97;

        setProgress((prev) => ({
          ...prev,
          progress: Math.max(prev.progress, Math.floor(progress)),
        }));
      }, 200);

      return {
        stop: () => {
          stop = true;
          clearInterval(interval);
        },
        completeTo100: async () => {
          stop = true;
          clearInterval(interval);

          // Rush to 100%
          setProgress((prev) => ({
            ...prev,
            progress: 100,
          }));
          await new Promise((res) => setTimeout(res, 500));
        },
      };
    };

    const finishTo100AndClose = async () => {
      await fake.completeTo100();
      setLoadingState({ open: false, message: "", progress: null });
    };
    // Initial message
    setLoadingState({
      open: true,
      message: "Generating Feature File",
      progress: 0,
    });

    fake = startProgress(setLoadingState);
    try {
      // Your API call to generate feature files
      // const generatedFeatureFileResponse = await featureFiles(testCase);
      const generatedFeatureFileResponse = await featureFilesWithToolCalling(testCase);

      // Make sure to define testCasesData
      const generatedFeatureFile = generatedFeatureFileResponse.data;
      await finishTo100AndClose();
      navigate(location.pathname, { state: { ...location.state, featureFileData: generatedFeatureFile }, replace: true })
    }
    catch (error) {
      const errorMsg = error?.response?.data?.Error || "An error occurred. Please try again.";
      setPopupMessage(errorMsg);
      setPopupOpen(true);
      if (error.response?.data?.Error === "Your session has expired.") {
        setSessionExpiredValue(true);
      }
      setLoadingState({ open: false, message: "", progress: null });
    }
    finally {
      // setLoading(false);
      setLoadingState({ open: false, message: "", progress: null });
    }
  };

  const handleProjectGeneration = async () => {
    let fake;

    const startProgress = (setProgress) => {
      let progress = 0;
      let stop = false;
      let finalMessageShown = false;

      const interval = setInterval(() => {
        if (stop) return;

        progress += 1.0;
        if (progress >= 97 && !finalMessageShown) {
          finalMessageShown = true;
          setLoadingState((prev) => ({
            ...prev,
            message: "Almost done! Fetching your output",
          }));
        }

        if (progress >= 97) progress = 97;

        setProgress((prev) => ({
          ...prev,
          progress: Math.max(prev.progress, Math.floor(progress)),
        }));
      }, 200);

      return {
        stop: () => {
          stop = true;
          clearInterval(interval);
        },
        completeTo100: async () => {
          stop = true;
          clearInterval(interval);

          // Rush to 100%
          setProgress((prev) => ({
            ...prev,
            progress: 100,
          }));
          await new Promise((res) => setTimeout(res, 500));
        },
      };
    };

    const finishTo100AndClose = async () => {
      await fake.completeTo100();
      setLoadingState({ open: false, message: "", progress: null });
    };
    // Initial message
    setLoadingState({
      open: true,
      message: "Generating Playwright java Project",
      progress: 0,
    });

    fake = startProgress(setLoadingState);

    try {
      const projectReqBody = {
        featureFileGenerated: featureFile,
        pageClassData: pageClass,
        stepDefinitionData: stepDefinition,
        testEnvironmentData: testEnvironment,
      };

      const projectFilesResponse = await SeleniumCucumberProjectWithToolCalling(projectReqBody);

      const pomXmlContent = projectFilesResponse.data["pomXmlContent"];
      const testRunnerClassContent = projectFilesResponse.data["testRunnerClassContent"];
      const testngSuiteFile = projectFilesResponse.data["testngSuiteFile"];
      const readmeFile = projectFilesResponse.data["readmeFile"];

      const utilsClassContent = `package utils;

  import org.apache.commons.io.FileUtils;
  import org.openqa.selenium.*;
  import org.openqa.selenium.NoSuchElementException;
  import org.openqa.selenium.interactions.Actions;
  import org.openqa.selenium.support.ui.*;

  import java.io.File;
  import java.io.IOException;
  import java.text.SimpleDateFormat;
  import java.time.Duration;
  import java.util.*;


  public class Utils {
      private static final long DEFAULT_TIMEOUT = 15;
      private static final long DEFAULT_POLLING = 1;
      private static final long IMPLICIT_TIME = 5;

      private WebDriver driver;
      private Actions action;
      private JavascriptExecutor js;

      public Utils(WebDriver driver) {
          this.driver = driver;
          this.action = new Actions(driver);
          this.js = (JavascriptExecutor) driver;
      }

      // ---------- Fluent Wait Core ----------
      public WebElement fluentWaitForElement(By locator, long timeout, long polling) {
          Wait<WebDriver> wait = new FluentWait<>(driver)
                  .withTimeout(Duration.ofSeconds(timeout))
                  .pollingEvery(Duration.ofSeconds(polling))
                  .ignoring(NoSuchElementException.class)
                  .ignoring(StaleElementReferenceException.class)
                  .ignoring(ElementClickInterceptedException.class);
          return wait.until(ExpectedConditions.visibilityOfElementLocated(locator));
      }

      public List<WebElement> fluentWaitForElements(By locator, long timeout, long polling) {
          Wait<WebDriver> wait = new FluentWait<>(driver)
                  .withTimeout(Duration.ofSeconds(timeout))
                  .pollingEvery(Duration.ofSeconds(polling))
                  .ignoring(NoSuchElementException.class)
                  .ignoring(StaleElementReferenceException.class);
          return wait.until(ExpectedConditions.visibilityOfAllElementsLocatedBy(locator));
      }

      public WebElement getWebElement(By locator) {
          return fluentWaitForElement(locator, DEFAULT_TIMEOUT, DEFAULT_POLLING);
      }

      public List<WebElement> getMatchingWebElements(By locator) {
          try {
              return fluentWaitForElements(locator, DEFAULT_TIMEOUT, DEFAULT_POLLING);
          } catch (Exception e) {
              return new ArrayList<>();
          }
      }

      public List<WebElement> findElements(By locator) {
          return getMatchingWebElements(locator);
      }

      // ---------- Element Interaction ----------
      public void clickElement(By locator) {
          getWebElement(locator).click();
      }

      public void clickAndWaitElement(By locator, int timer) {
          getWebElement(locator).click();
      }

      public void doubleClick(By locator) {
          action.doubleClick(getWebElement(locator)).perform();
      }

      public void jsClickElement(By locator) {
          js.executeScript("arguments[0].click();", getWebElement(locator));
      }

      public void inputText(By locator, String sText) {
          getWebElement(locator).sendKeys(sText);
      }

      public void clearAndInputText(By locator, String sText) {
          WebElement ele = getWebElement(locator);
          ele.clear();
          ele.sendKeys(sText);
      }

      public void clearInput(By locator, String sText) {
          getWebElement(locator).clear();
      }

      public void scrollToElement(By locator) {
          js.executeScript("arguments[0].scrollIntoView(true);", getWebElement(locator));
      }

      public void hoverOverElement(By locator) {
          action.moveToElement(getWebElement(locator)).perform();
      }

      public String getText(By locator) {
          try {
              return getWebElement(locator).getText();
          } catch (Exception e) {
              return null;
          }
      }

      public String getAttribute(By locator, String sAttrKey) {
          return getWebElement(locator).getAttribute(sAttrKey);
      }

      public boolean isElementPresent(By locator) {
          try {
              getWebElement(locator);
              return true;
          } catch (Exception e) {
              return false;
          }
      }

      public boolean isAttributePresent(By locator, String sAttrKey) {
          try {
              return getWebElement(locator).getAttribute(sAttrKey) != null;
          } catch (Exception e) {
              return false;
          }
      }

      public boolean isElementVisible(By locator, long iTimeInSeconds) {
          try {
              waitUntilElementIsVisible(locator, iTimeInSeconds);
              return true;
          } catch (Exception e) {
              return false;
          }
      }

      public boolean isElementVisible(By locator) {
          return isElementVisible(locator, DEFAULT_TIMEOUT);
      }

      public boolean isAlertVisible() {
          try {
              waitForAlert(DEFAULT_TIMEOUT);
              return true;
          } catch (NoAlertPresentException e) {
              return false;
          }
      }

      // ---------- Waits ----------
      public void waitUntilElementIsVisible(By locator, long iTimeout) {
          new WebDriverWait(driver, Duration.ofSeconds(iTimeout))
                  .until(ExpectedConditions.visibilityOfElementLocated(locator));
      }

      public void waitUntilElementIsInVisible(By locator, long iTimeout) {
          new WebDriverWait(driver, Duration.ofSeconds(iTimeout))
                  .until(ExpectedConditions.invisibilityOfElementLocated(locator));
      }

      public void waitForAlert(long iTimeout) {
          new WebDriverWait(driver, Duration.ofSeconds(iTimeout))
                  .until(ExpectedConditions.alertIsPresent());
      }

      public void waitUntilElementIsClickable(By locator, long iTimeout) {
          new WebDriverWait(driver, Duration.ofSeconds(iTimeout))
                  .until(ExpectedConditions.elementToBeClickable(locator));
      }

      public void waitTillClickableAndClick(By locator, long iTimeout) {
          for (int i = 0; i < iTimeout; i++) {
              try {
                  clickElement(locator);
                  break;
              } catch (Exception ignored) {}
          }
      }

      public void waitForFrameAndSwitch(By locator, long iTimeout) {
          new WebDriverWait(driver, Duration.ofSeconds(iTimeout))
                  .until(ExpectedConditions.frameToBeAvailableAndSwitchToIt(locator));
      }

      // ---------- Frame & Window ----------
      public void switchToFrame(By locator) {
          driver.switchTo().frame(getWebElement(locator));
      }

      public void switchToDefault() {
          driver.switchTo().defaultContent();
      }

      public void openNewWindowWithURL(String sURL) {
          js.executeScript("window.open()");
          ArrayList<String> tabs = new ArrayList<>(driver.getWindowHandles());
          driver.switchTo().window(tabs.get(1));
          driver.get(sURL);
      }

      public void closeCurrentWindow() {
          ArrayList<String> tabs = new ArrayList<>(driver.getWindowHandles());
          driver.close();
          if (!tabs.isEmpty()) {
              driver.switchTo().window(tabs.get(0));
          }
      }

      public void switchToWindow(String windowHandle) {
          driver.switchTo().window(windowHandle);
      }

      public void switchToNewWindow() {
          String mainWindow = driver.getWindowHandle();
          Set<String> handles = driver.getWindowHandles();
          for (String handle : handles) {
              if (!handle.equals(mainWindow)) {
                  driver.switchTo().window(handle);
                  return;
              }
          }
          throw new NoSuchWindowException("No new window found to switch to.");
      }

      // ---------- Screenshot ----------
      public String takeScreenshotAndSave(String screenshotName) {
          File scrFile = takeScreenShot();
          String destFile = screenshotName + ".png";
          String filePath = File.separator + destFile;
          try {
              FileUtils.copyFile(scrFile, new File(filePath));
          } catch (IOException e) {
              throw new RuntimeException("Screenshot not saved properly: " + e.getMessage());
          }
          return filePath;
      }

      public String takeScreenshotAndSave() {
          return takeScreenshotAndSave("Screenshot_" + getCurrentTime());
      }

      private File takeScreenShot() {
          return ((TakesScreenshot) driver).getScreenshotAs(OutputType.FILE);
      }

      // ---------- Alerts ----------
      public void acceptAlert() {
          driver.switchTo().alert().accept();
      }

      public void dismissAlert() {
          driver.switchTo().alert().dismiss();
      }

      // ---------- Other ----------
      public void refresh() {
          driver.navigate().refresh();
      }

      public void highLightElement(WebElement element) {
          js.executeScript("arguments[0].style.border='3px solid red'", element);
      }

      public static String getCurrentTime() {
          return new SimpleDateFormat("yyyy.MM.dd.HH.mm.ss").format(new java.util.Date());
      }
  }
  `;
      const zip = new JSZip();
      zip.file("src/main/java/utils/Utils.java", utilsClassContent);

      // Add the modified `pom.xml` content
      zip.file("pom.xml", pomXmlContent);

      if (!!testngSuiteFile) {
        zip.file("testngSuite.xml", testngSuiteFile);
      }

      // Add the readme file
      if (readmeFile) {
        zip.file("README.md", readmeFile);
      }

      if (testRunnerClassContent)
        zip.file("src/test/java/tests/TestRunner.java", testRunnerClassContent);

      const generateVariablesFile = (data) => {
        return `
        # Configuration file for Selenium tests

        ${data.url ? `url = ${data.url}` : ""}
        ${data.browser ? `browser = ${data.browser}` : ""}
        ${data.os ? `os = ${data.os}` : ""}
        ${data.username ? `username = ${data.username}` : ""}
        ${data.password ? `password = ${data.password}` : ""}
        `.trim();
      };

      zip.file(
        "src/test/resources/config.properties",
        generateVariablesFile(testEnvironment)
      );

      zip.file("src/test/resources/features/featureFiles.feature", featureFile);

      pageClass.forEach((pageClass) => {
        const classname = Object.keys(pageClass)[0];
        const classcontent = pageClass[classname];

        const filepath = `src/test/java/pages/${classname}.java`;
        zip.file(filepath, classcontent);
      });
      if (typeof stepDefinition === "string") {
        zip.file("src/test/java/gluecode/StepDefinitions.java", stepDefinition);
      } else if (Array.isArray(stepDefinition)) {
        stepDefinition.forEach((stepdef) => {
          const classname = Object.keys(stepdef)[0];
          const classcontent = stepdef[classname];

          const filepath = `src/test/java/gluecode/${classname}.java`;
          zip.file(filepath, classcontent);
        });
      }
      zip.generateAsync({ type: "blob" }).then((content) => {
        setZipBlob(content); // store in local state
        saveAs(content, "Selenium_Java_Cucumber_Project");
      });
    } catch (error) {
      const errorMsg =
        error?.response?.data?.Error || "An error occurred. Please try again.";
      setPopupMessage(errorMsg);
      setPopupOpen(true);
      setLoadingState({ open: false, message: "", progress: null });
    } finally {
      setLoadingState({ open: false, message: "", progress: null });
    }
  };


  const primaryFieldsObject = getPrimaryFields(locator);
  const handlePageClass = async () => {
    // setLoading(true);
    let fake;
    const startProgress = (setProgress) => {
      let progress = 0;
      let stop = false;
      let finalMessageShown = false;
      const interval = setInterval(() => {
        if (stop) return;
        progress += 1.8;
        if (progress >= 97 && !finalMessageShown) {
          finalMessageShown = true;
          setLoadingState((prev) => ({
            ...prev,
            message: "Almost done! Fetching your output",
          }));
        }
        if (progress >= 97) progress = 97;
        setProgress((prev) => ({
          ...prev,
          progress: Math.max(prev.progress, Math.floor(progress)),
        }));
      }, 200);
      return {
        stop: () => {
          stop = true;
          clearInterval(interval);
        },
        completeTo100: async () => {
          stop = true;
          clearInterval(interval);

          // Rush to 100%
          setProgress((prev) => ({
            ...prev,
            progress: 100,
          }));
          await new Promise((res) => setTimeout(res, 500));
        },
      };
    };

    const finishTo100AndClose = async () => {
      await fake.completeTo100();
      setLoadingState({ open: false, message: "", progress: null });
    };
    // Initial message
    setLoadingState({
      open: true,
      message: "Generating Page Classes",
      progress: 0,
    });

    fake = startProgress(setLoadingState);
    try {
      const requestData = {
        "featureFile": featureFile,
        "locators": primaryFieldsObject,
      };

      // const generatedPageClassGenerated = await pageClassAPI(primaryFieldsObject, location.state?.framework);
      const generatedPageClassGenerated = await pageClassAPIWithToolCalling(requestData, location.state?.framework);
      const generatedPageClass = generatedPageClassGenerated.data;
      navigate(location.pathname, { state: { ...location.state, generatedPageclassData: generatedPageClass }, replace: true });
    }
    catch (error) {
      const errorMsg = error?.response?.data?.Error || "An error occurred. Please try again.";
      setPopupMessage(errorMsg);
      setPopupOpen(true);
      if (error.response?.data?.Error === "Your session has expired.") {
        setSessionExpiredValue(true);
      }
      setLoadingState({ open: false, message: "", progress: null });
    }
    finally {
      // setLoading(false);
      setLoadingState({ open: false, message: "", progress: null });
    }

  }
  const handleStepDefinition = async () => {
    // setLoading(true);
    let fake;

    const startProgress = (setProgress) => {
      let progress = 0;
      let stop = false;
      let finalMessageShown = false;

      const interval = setInterval(() => {
        if (stop) return;

        progress += 0.0001;
        if (progress >= 97 && !finalMessageShown) {
          finalMessageShown = true;
          setLoadingState((prev) => ({
            ...prev,
            message: "Almost done! Fetching your output",
          }));
        }

        if (progress >= 97) progress = 97;

        setProgress((prev) => ({
          ...prev,
          progress: Math.max(prev.progress, Math.floor(progress)),
        }));
      }, 200);

      return {
        stop: () => {
          stop = true;
          clearInterval(interval);
        },
        completeTo100: async () => {
          stop = true;
          clearInterval(interval);

          // Rush to 100%
          setProgress((prev) => ({
            ...prev,
            progress: 100,
          }));
          await new Promise((res) => setTimeout(res, 500));
        },
      };
    };

    const finishTo100AndClose = async () => {
      await fake.completeTo100();
      setLoadingState({ open: false, message: "", progress: null });
    };
    // Initial message
    setLoadingState({
      open: true,
      message: "Generating Step Definition",
      progress: 0,
    });

    fake = startProgress(setLoadingState);
    try {
      const pageClassData = {
        "pageClassGenerated": pageClass
      };
      // const generatedStepDefinitionGenerated = await stepDefinitionAPI({ featureFileGenerated: featureFile, pageClassData }, location.state?.framework);
      const generatedStepDefinitionGenerated = await stepDefinitionWithToolCallingAPI({ featureFileGenerated: featureFile, pageClassData, configProperties: testEnvironment }, location.state?.framework);

      const generatedStepDefinition = generatedStepDefinitionGenerated.data;
      navigate(location.pathname, { state: { ...location.state, generatedStepDefinitionData: generatedStepDefinition }, replace: true });
    }
    catch (error) {
      const errorMsg = error?.response?.data?.Error || "An error occurred. Please try again.";
      setPopupMessage(errorMsg);
      setPopupOpen(true);
      if (error.response?.data?.Error === "Your session has expired.") {
        setSessionExpiredValue(true);
      }
      setLoadingState({ open: false, message: "", progress: null });
    }
    finally {
      // setLoading(false);
      setLoadingState({ open: false, message: "", progress: null });
    }

  }
  const handleGitHubProject = async () => {
    console.log("Navigating to GitHub with zipBlob:", zipBlob);

    if (!zipBlob) {
      console.error("ZIP file not generated yet.");
      return;
    }
    navigate(`/dashboard/test-automation/newproject-gitcredentials`, {
      state: {
        framework: framework,
        projectType: projectType,
        zipFile: zipBlob,
      },
    });
  };

  const projectGenerationButton = [

    {
      label: "Generate Project",
      variant: "contained",
      onClick: handleProjectGeneration,
      startIcon: <GenerateButton />,
      sx: { float: "right" },
    },
    {
      label: "Push to GitHub",
      variant: "contained",
      startIcon: <GenerateButton />,
      sx: { marginRight: 1, whiteSpace: "nowrap" },
      onClick: handleGitHubProject,
      disabled: !zipBlob, // Disable if zipBlob is not available
    },
  ]

  function getPrimaryFields(response) {
    const primaryFields = {};
    for (const key in response) {
      if (response[key].primary) {
        if (response[key].primary[0].startsWith("class")) {
          primaryFields[key] = response[key].secondary;
        } else {
          primaryFields[key] = response[key].primary;
        }
      }
    }
    return primaryFields;
  };
  const handleDownloadClick = () => {
    setDownloadOpen(true);
  };
  const testcaseNextButton = {
    label: "Generate Feature File",
    onClick: handleGenerateTestCases,
    startIcon: <GenerateButton />,
    variant: "contained",
    sx: { float: "right" },
  };

  const javaSeliniumDownloadButton = {
    label: "Download",
    onClick: handleDownloadClick,
    variant: "text",
    startIcon: <SaveAltRoundedIcon />,
    sx: { textTransform: "none" },
  };

  const locatorsNextButton = {
    label: "Generate Page Class",
    variant: "contained",
    onClick: handlePageClass,
    startIcon: <GenerateButton />,
    sx: { float: "right" },
  }
  const stepDefinitionNextButton = {
    label: "Generate Step Definition",
    variant: "contained",
    onClick: handleStepDefinition,
    startIcon: <GenerateButton />,
    sx: { float: "right" },
  }
  const handleCloseDownload = () => {
    setDownloadOpen(false);
  }
  const formatTestPlan = (testPlanData) => {
    const formattedTestPlan = {};
    Object.entries(testPlanData).map(([key, value]) => {
      // console.log(typeof value);
      // console.log(value)
      if (Array.isArray(value)) {
        return (formattedTestPlan[key] = flattenArray(value));
      }
      if (!!value && typeof value === "object") {
        return (formattedTestPlan[key] = flattenObject(value));
      }
      return (formattedTestPlan[key] = value);
    });
    // console.log(formattedTestPlan)
    return formattedTestPlan;
  };


  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        flexGrow: 1,
      }}
    >

      <Box sx={{ maxHeight: "100%", width: "100%" }}>
        {/* Fixed breadcrumb where you want it */}
        <Box
          sx={{
            position: "sticky",
            top: "0", // Adjust this value as needed to place the breadcrumb where you want it
            width: "100%",
            zIndex: 1000, // Ensure it stays above other content
            bgcolor: "white", // Background color to prevent transparency
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)", // Optional shadow for visual separation
          }}
        >


          <QMentisBreadCrumb breadCrumbs={breadCrumbs} sx={{ height: "56px" }} />
        </Box>
        <Box
          sx={{
            display: "flex",
            bgcolor: "#f6f3f2",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "center",
            overflowY: "auto",
            width: "100%",
            height: "80vh",
            minHeight: "80vh",
            position: "relative",
            WebkitOverflowScrolling: "touch",
            scrollbarWidth: "thin",

            "&::-webkit-scrollbar": {
              width: "8px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#888",
              borderRadius: "4px",
              minHeight: "20px",
            },
            "&::-webkit-scrollbar-thumb:hover": {
              backgroundColor: "#555",
            },
          }}
        >
          <Box
            sx={{
              width: "100%",
              maxWidth: "600px",
              margin: "10px auto",
              "& > *:not(:last-child)": {
                marginBottom: "16px", // Adds margin between components but not after the last one
              },
            }}
          >
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              mb={0.1}
            >
              <Box display="flex" alignItems="center" mb={0.1}>
                <AutomateIcon style={{ marginRight: 4 }} />
                <Typography
                  variant="body2"
                  color="text.secondary"
                  gutterBottom
                  sx={{ mt: 0.5 }}
                >
                  Generate automated test scripts
                </Typography>
              </Box>
              <FullscreenToggle />




            </Box>
            {/* JAVA SELENIUM COMPONENTS */}
            {/* {Object.entries(testEnvironment).length === 0 && ( */}
            <TestEnvironmentForm
              testEnvironmentData={testEnvironment}
              setTestEnviorment={setTestEnviorment}
              framework={location.state?.framework}
              projectType={location.state?.projectType}
              confirmed={confirmed}
              setConfirmed={setConfirmed}
            />
            {/* )} */}

            {/* <UploadBox testCaseData={testCase} setTestCase={setTestCase} testcaseNextButton={testcaseNextButton} javaSeliniumDownloadButton={javaSeliniumDownloadButton} /> */}
            {confirmed && (
              <UploadBox
                testCaseData={testCase}
                setTestCase={setTestCase}
                testcaseNextButton={testcaseNextButton}
                javaSeliniumDownloadButton={javaSeliniumDownloadButton}
              />
            )}
            {Object.entries(testCase).length > 0 && <TestCaseUI testCaseData={testCase} setTestCase={setTestCase} testcaseNextButton={testcaseNextButton} javaSeliniumDownloadButton={javaSeliniumDownloadButton} projectType={projectType} />}
            {!!featureFile && featureFile !== "" && <Feature featureFile={featureFile} setFeatureFile={setFeatureFile} projectType={projectType} />}
            {!!featureFile && featureFile !== "" && <InputForm setPageSource={setPageSource} />}
            {Object.entries(locator).length > 0 && <Locators locator={locator} setLocator={setLocator} locatorsNextButton={locatorsNextButton} projectType={projectType} />}
            {!!pageClass && pageClass !== "" && <PageClass pageClass={pageClass} setPageClass={setPageClass} featureFile={featureFile}
              stepDefinitionNextButton={stepDefinitionNextButton}
              projectType={projectType}
            />}
            {!!stepDefinition && stepDefinition !== "" && <StepDefinition stepDefinition={stepDefinition} setstepDefinition={setstepDefinition} featureFile={featureFile} pageClass={pageClass} framework={location.state?.framework} projectType={projectType} testEnvironmentData={testEnvironment} nextButton={projectGenerationButton} />}
          </Box>
        </Box>
        {/* Add padding-top to avoid overlap with the fixed breadcrumb */}
        <Container
          sx={{
            // paddingTop: "50px", // Adjust this value based on the height of the breadcrumb
            width: "100%",
          }}
        >


          {/* <TestCaseFlowDataContext.Provider
            value={{
              testCaseDetails,
              setTestCaseDetails,
              featureFiles,
              setFeatureFiles,
              pageSources,
              setPageSources,
              locators,
              setLocators,
              pageClasses,
              setPageClasses,
              stepDefinitions,
              setstepDefinitions,

            }}
          > */}


          {/* <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '70vh' }}>
              <Button
                startIcon={<DownloadIcon />}
                color="#80c3d8"
                sx={{ textTransform: "none", marginRight: '15px', color: '#53adcb', border: '2px solid #53adcb', }}
              >
                Upload
              </Button>
            </Box> */}



          {/* </TestCaseFlowDataContext.Provider> */}
        </Container>
      </Box>
      <Box
        component="footer"
        sx={{
          width: "100%",
          maxWidth: "601px",
          backgroundColor: "#f6f3f2",
          textAlign: "center",
          paddingX: "5px",
          position: "fixed",
          bottom: "0",
          zIndex: "99",
        }}
      >
        <Typography variant="caption" color="textSecondary">
          Use QMentisAI™ with human supervision, as with all generative AI tools.
        </Typography>
      </Box>
      <MessagePopup
        modalOpen={popupOpen}
        okayHandler={() => setPopupOpen(false)}
        message={popupMessage}
      />
      <CommonDownload open={downloadOpen} onClose={handleCloseDownload}
        wordData={[
          {
            type: "subParagraphs",
            data: testCase,
          },
        ]}
        serviceName={"Test Case Details"}
        serviceResponse={formatTestPlan(testCase)}
        documents={['xls', 'csv']}
      />
    </Box>
  );
};


export default JavaSeleniumNewProjectOutputPage;